import './screen-reader-only.css';
export var screenReaderOnly = '_1y7th170-3-5-0';